import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../src/views/Home.vue'
import Login from '../src/views/Login.vue'
import UpdateUser from '../src/views/users/EditUser/EditUserPasswordForm.vue'
import CreateUser from '../src/views/users/CreateUser/CreateUserForm.vue'
import DeleteUser from '../src/views/users/DeleteUser/DeleteUserForm.vue'
import UserPanel from '../src/views/users/Panel.vue'
import HidroQuery from './views/dataQuery/ClimatologicalData/ClimatologicalForm.vue'
import AirQueryIn from '../src/views/dataQuery/AirQualityData/AirQualityForm.vue'
import AirQueryEm from './views/dataQuery/AirQualityData/AirQualityEm.vue'
import GroundWater from '../src/views/dataQuery/GroundWaterData/GroundWaterForm.vue'
import Hydrological from '../src/views/dataQuery/HydrologicalData/HydrologicalForm.vue'
import ResultAirQuality from '../src/views/resultQuery/ResultAirQuality.vue'
import ResultClimatological from '../src/views/resultQuery/ResultClimatological.vue'
import ResultGroundWater from '../src/views/resultQuery/ResultGroundWater.vue'
import ResultHydrological from '../src/views/resultQuery/ResultHydrological.vue'
import ClimatologicalInformationPdf from '../src/views/IndicatorsInformation/ClimatologicalInformationPdf/ClimatologicalInformationPdf.vue'
import GroundWaterInformationPdf from '../src/views/IndicatorsInformation/GroundWaterInformationPdf/GroundWaterInformationPdf.vue'
import AirQualityInformationPdf from '../src/views/IndicatorsInformation/AirQualityInformationPdf/AirQualityInformationPdf.vue'
import HydrologicalInformationPdf from '../src/views/IndicatorsInformation/HydrologicalInformationPdf/HydrologicalInformationPdf.vue'
import PasswordReset from './views/PasswordReset/PasswordReset.vue'
import PasswordResetEmail from './views/PasswordReset/PasswordResetEmail.vue'

const routes = [
        {
                path: '/',
                name: 'home',
                component: Home
        },
        {
                path: '/login',
                name: 'login',
                component: Login
        },
        {
                path:'/userPanel',
                name: 'userPanel',
                component: UserPanel
        }
        ,
        {
                path: '/CreateUser',
                name: 'CreateUser',
                component: CreateUser
        },
        {
                path: '/DeleteUser',
                name: 'DeleteUser',
                component: DeleteUser
        },
        {
                path: '/UpdateUser',
                name: 'UpdateUser',
                component: UpdateUser
        },
        {
                path: '/hidroQuery',
                name: 'hidroQuery',
                component: HidroQuery
        },
        {
                path: '/airQualityInQuery',
                name: 'airQualityInQuery',
                component: AirQueryIn
        },
        {
                path:'/airQualityEmQuery',
                name:'airQualityEmQuery',
                component: AirQueryEm
        },
        {
                path:'/groundWaterQuery',
                name:'groundWaterQuery',
                component: GroundWater
        },
        {
                path: '/hydrologicalQuery',
                name: 'hydrologicalQuery',
                component: Hydrological
        },
        {
                path: '/resultClimatological',
                name: 'resultClimatological',
                component: ResultClimatological
        },
        {
                path: '/resultAirQuality',
                name: 'resultAirQuality',
                component: ResultAirQuality
        },
        {
                path: '/resultGroundWater',
                name: 'resultGroundWater',
                component: ResultGroundWater
        },
        {
                path: '/resultHydrological',
                name: 'resultHydrological',
                component: ResultHydrological
        },
        {
                path: '/ClimatologicalInformationPdf',
                name: 'ClimatologicalInformationPdf',
                component: ClimatologicalInformationPdf
        },
        {
                path: '/GroundWaterInformationPdf',
                name: 'GroundWaterInformationPdf',
                component: GroundWaterInformationPdf
        },
        {
                path: '/AirQualityInformationPdf',
                name: 'AirQualityInformationPdf',
                component: AirQualityInformationPdf
        },
        {
                path: '/HydrologicalInformationPdf',
                name: 'HydrologicalInformationPdf',
                component: HydrologicalInformationPdf
        },
        {
                path: '/PasswordReset',
                name: 'PasswordReset',
                component: PasswordReset
        },
        {
                path: '/PasswordResetEmail',
                name: 'PasswordResetEmail',
                component: PasswordResetEmail
        }
]

const router = createRouter({
        history: createWebHashHistory(),
        routes
})

export default router